import { CommonModule, NgIf } from '@angular/common';
import { Component, NgModule, Input, OnInit, inject } from '@angular/core';
import { Router, RouterModule, RouterLink } from '@angular/router';

import { DxFormModule } from 'devextreme-angular/ui/form';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import { DxButtonModule, DxButtonTypes } from 'devextreme-angular/ui/button';
import { DxTextBoxModule } from 'devextreme-angular/ui/text-box';
import notify from 'devextreme/ui/notify';
import { AppInfoService, AuthService, IResponse, ThemeService } from 'src/app/services';
import { DxiItemModule, DxiValidationRuleModule, DxoLabelModule, DxoButtonOptionsModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { DxButtonModule as DxButtonModule_1, DxValidatorModule } from 'devextreme-angular';

@Component({
    selector: 'app-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss'],
    imports: [
        DxFormModule,
        DxiItemModule,
        DxiValidationRuleModule,
        DxoLabelModule,
        DxoButtonOptionsModule,
        DxTemplateModule,
        DxTextBoxModule,
        DxValidatorModule,
        NgIf,
        DxLoadIndicatorModule,
        DxButtonModule_1
    ]
})
export class LoginFormComponent implements OnInit {
  @Input() resetLink = '/auth/reset-password';
  @Input() createAccountLink = '/auth/create-account';

  appInfo = inject(AppInfoService);
  authService = inject(AuthService);
  router = inject(Router);
  themeService = inject(ThemeService);

  defaultAuthData: IResponse;

  btnStylingMode: DxButtonTypes.ButtonStyle;

  loading = false;
  formData: any = {};

  constructor() {
    this.themeService.isDark.subscribe((value: boolean) => {
      this.btnStylingMode = value ? 'outlined' : 'contained';
    });
  }

  async ngOnInit(): Promise<void> {
    console.log('LoginFormComponent ngOnInit');
    if (this.authService.loggedIn()) {
      await this.authService.logOut();
    }
    // this.defaultAuthData = await this.authService.getUser();
    // console.log('defaultAuthData', this.defaultAuthData);
  }

  async onSubmit(e: Event) {
    e.preventDefault();
    const { email, password } = this.formData;
    this.loading = true;

    const result = await this.authService.logIn(email, password);
    this.loading = false;
    if (!result.isSuccess) {
      this.appInfo.notify(result.detail, 'error');
      return;
    }

    this.router.navigate(['/']);
  }

  onCreateAccountClick = () => {
    this.router.navigate([this.createAccountLink]);
  };
}
